const ofLength = len => value => {
    return value && value.length != len ? `Must be ${len} length` : undefined
    return undefined;
}

export default ofLength;